import { render, staticRenderFns } from "./trainingBudget.vue?vue&type=template&id=c082a494"
import script from "./trainingBudget.vue?vue&type=script&lang=js"
export * from "./trainingBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports